import React, { useState, useEffect, useMemo } from "react";
import useMappedState from "@src/utils/useMappedState";
import { Button, Pagination } from "@cloud/atom-ui";
import "./style.m.less";
import { i18n } from "@src/utils/i18n";
import * as nls from "./nls";
import { GetDevelopThunk, getAppRole } from "./thunk";
import SelectPerson from "./components/SelectPerson";
import history from "@src/utils/history";
import LoadingOutlined from "@cloud/atom-ui-icons/LoadingOutlined";
import VersionTip from "../../components/version-tip";
import { getAppPathFromType, APP_TYPE } from "@src/utils/common";

const I18N = i18n(nls);
const text = I18N;
export default props => {
  //appId   应用id
  //type 类型，1内部应用，3第三方应用
  const { user } = useMappedState("root");
  const {
    history: {
      queryParams: {
        query: { id: appId }
      }
    }
  } = props;
  const {
    match: {
      params: { type }
    }
  } = props;

  const [role, setRole] = useState(1); // 1表示开发者; 其他为协同开发者
  const [appOwners, setAppOwners] = useState([]); //应用责任人
  const [appDevelopmenters, setAppDevelopmenters] = useState([]); //开发者
  const [appDevelopmentersShow, setAppDevelopmentersShow] = useState([]); //开发者分页数据
  const [appDevelopmentersPage, setAppDevelopmentersPage] = useState(1); //开发者分页页数

  const [showPersonModal, setPersonModal] = useState(false); //是否显示弹窗
  const [personConfig, setPersonConfig] = useState({}); //弹窗配置信息
  /// 展示人员操作界面
  /// type：1开发者 0责任人
  const showSelectPerson = function(type) {
    setPersonModal(true);
    if (type == 0) {
      setPersonConfig({
        list: appOwners,
        type
      });
    } else {
      setPersonConfig({
        list: appDevelopmenters,
        type
      });
    }
  };

  /// 获得开发者展示数据
  /// page: 页数
  const getDevelopShowData = page => {
    setAppDevelopmentersShow(
      appDevelopmenters
        ? appDevelopmenters.slice((page - 1) * 10, page * 10)
        : []
    );
    setAppDevelopmentersPage(page);
  };

  /// 加载开发者/责任人区域dom
  /// result：人员列表
  /// length：总数
  /// titleIfo：标题信息
  /// type：1开发者 0责任人
  /// b:是否可以编辑
  let structorDom = (result, length, titleIfo, type, b) => {
    const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

    return (
      <>
        <div className="wecode-header bottom-line">
          <div className="wecode-header-title">
            <span>{titleIfo.title}</span>
            <span>{titleIfo.tip}</span>
          </div>
          {b ? (
            <Button
              style={{ height: "30px" }}
              onClick={() => showSelectPerson(type)}
            >
              {text.edit}
            </Button>
          ) : null}
        </div>
        <div className="wecode-list">
          <div className="wecode-list-header bottom-line">
            <div className="list-item">{text.memberInfo.name}</div>
            <div className="list-item">{text.memberInfo.accout}</div>
            <div className="list-item">{text.memberInfo.email}</div>
          </div>
          <div className="wecode-list-body">
            {result &&
              result.map((item, index) => (
                <div key={index} className="wecode-list-item bottom-line">
                  <div className="list-item" title={item.chineseName}>
                    {item.chineseName}
                  </div>
                  <div className="list-item" title={item.accountId}>
                    {item.accountId}
                  </div>
                  <div className="list-item" title={item.personMail}>
                    {item.personMail}
                  </div>
                </div>
              ))}
            {type == APP_TYPE.innerapp && (
              <Pagination
                onChange={getDevelopShowData}
                total={length}
                className="wecode-list-pagination"
              />
            )}
          </div>
        </div>
      </>
    );
  };

  //获得数据
  const init = async () => {
    //获得责任人
    setAppOwners(
      await GetDevelopThunk(appId, 0, 1, 5, getAppPathFromType(type))
    );
    //获得开发者
    GetDevelopThunk(appId, 1, 1, 50, getAppPathFromType(type)).then(data => {
      setAppDevelopmenters(data);
      setAppDevelopmentersShow(
        data
          ? data.slice(
              (appDevelopmentersPage - 1) * 10,
              appDevelopmentersPage * 10
            )
          : []
      );
    });

    //获得人员信息
    getAppRole(appId, getAppPathFromType(type)).then(result => {
      if (result.status === 1) {
        setRole(result?.data);
      } else {
        localStorage.setItem(
          "appInfo",
          JSON.stringify({ appName: "", appId: "" })
        );
        history.push(`/${type}/wecode-v2`);
        return;
      }
    });
  };
  useEffect(() => {
    init();
  }, [showPersonModal]);

  return (
    <div className="app-member-body">
      <VersionTip
        style={{ marginTop: "3px", marginBottom: "29px" }}
      ></VersionTip>
      <p className="member-title">成员管理</p>
      <div className="app-member">
        {structorDom(
          appOwners,
          appOwners.length,
          text.appresponsiberInfo,
          0,
          role === 1 || user.isAdmin
        )}
        {structorDom(
          appDevelopmentersShow,
          appDevelopmenters.length,
          text.collaborativeDevInof,
          1,
          role === 1 || user.isAdmin
        )}
        {showPersonModal && (
          <SelectPerson
            showModalFlag={showPersonModal}
            selectedData={personConfig.list}
            userType={personConfig.type}
            type={type}
            appId={appId}
            onclose={() => {
              setPersonModal(false);
            }}
          ></SelectPerson>
        )}
      </div>
    </div>
  );
};
